import { FileTextOutlined } from '@ant-design/icons';
import { ColumnsType } from 'antd/lib/table';
import Flag from 'react-flagpack';

import { Checkbox, ErrorBoundary } from '../../../../../components/index';
import { CargoSuppressionReportItemType } from '../../../../../services/cargoSuppressionApi';
import { createDateStringPtBr } from '../../../../../utils/utils';

export type SelectionKey = { docking_code: string; docking_year: number };

export function rowKeyFor(
  record: Pick<CargoSuppressionReportItemType, 'docking_code' | 'docking_year'>
) {
  return `${record.docking_code}-${record.docking_year}`;
}

export function isRecordSelected(
  selected: SelectionKey[],
  record: Pick<CargoSuppressionReportItemType, 'docking_code' | 'docking_year'>
) {
  return selected.some(
    (s) =>
      s.docking_code === record.docking_code &&
      s.docking_year === record.docking_year
  );
}

export function columns(
  selected: SelectionKey[],
  onSelectItem: (
    checked: boolean,
    record: CargoSuppressionReportItemType
  ) => void,
  checkedAll: boolean,
  onCheckedAll: (value: boolean) => void
): ColumnsType<Record<string, any>> {
  return [
    {
      title() {
        return (
          <Checkbox
            defaultChecked={checkedAll}
            checked={checkedAll}
            onChange={(e) => onCheckedAll(e.target.checked)}
          />
        );
      },
      width: '5%',
      dataIndex: 'is_selected',
      render(_, record) {
        const typed = record as CargoSuppressionReportItemType;
        return (
          <Checkbox
            checked={isRecordSelected(selected, typed)}
            onChange={(e) => onSelectItem(e.target.checked, typed)}
          />
        );
      },
    },
    {
      title: 'atracação',
      dataIndex: 'docking_code',
      width: '18%',
      sorter: {
        compare: (a: any, b: any) =>
          a.docking_code?.localeCompare(b.docking_code),
        multiple: 1,
      },
    },
    {
      title: 'embarcação',
      dataIndex: 'vessel_flag',
      width: '30%',
      sorter: {
        compare: (a: any, b: any) =>
          (a.vessel_name || '').localeCompare(b.vessel_name || ''),
        multiple: 1,
      },
      render: (value, record) => {
        return (
          <div style={{ display: 'flex', gap: '4px' }}>
            <div style={{ width: '20px' }}>
              {value && (
                <ErrorBoundary replace="">
                  <Flag code={value} size="m" />
                </ErrorBoundary>
              )}
            </div>
            <span
              style={{
                textTransform: 'capitalize',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}
            >
              {record.vessel_name?.toLowerCase() || ''}
            </span>
          </div>
        );
      },
    },
    {
      title: 'berço',
      dataIndex: 'docking_berth_code',
      width: '18%',
      sorter: {
        compare: (a: any, b: any) =>
          (a.docking_place_name || a.docking_berth_code || '').localeCompare(
            b.docking_place_name || b.docking_berth_code || ''
          ),
        multiple: 1,
      },
      render: (value, record) => record.docking_place_name || value,
    },
    {
      title: 'status xml',
      dataIndex: 'last_date_xml',
      width: '20%',
      sorter: {
        compare: (a: any, b: any) =>
          (a.last_date_xml || '').localeCompare(b.last_date_xml || ''),
        multiple: 1,
      },
      render: (value) =>
        value ? (
          createDateStringPtBr(value)
        ) : (
          <div>
            <FileTextOutlined style={{ color: 'var(--neutral_medium)' }} />
            <i style={{ color: 'var(--neutral_medium)', marginLeft: '5px' }}>
              Ainda não gerado
            </i>
          </div>
        ),
    },
  ];
}
